import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banner absolute bottom-0 right-0 w-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This site uses cookies to deliver our services. By using our site, you acknowledge that you have read and understand our "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-primary-default",
    href: "https://sendmeglobal.de/privacy"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-primary-default",
    href: "https://sendmeglobal.de/terms-of-use-others"
  }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(". Your use of our products and services is subject to these policy and terms. ")
], -1)
const _hoisted_3 = { class: "space-x-3 mt-3" }

import { ref } from 'vue';
import { bootstrap } from 'vue-gtag';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'CookieBanner',
  setup(__props) {

const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts?.pop()?.split(';').shift();
};
const showCookieBanner = ref(getCookie('__allowCookie') ? 0 : 1);

const setAllowCookie = async (value: number) => {
  if (value === 1) {
    const gtag = await bootstrap();
    console.log(gtag);
  }
  document.cookie = `__allowCookie=${value}; domain=.sendmeglobal.de; path=/`;
  showCookieBanner.value = 0;
};

const deleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim();

    if (name !== '__allowCookie') {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (showCookieBanner.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "p-2 border border-black rounded focus:bg-blue-400 hover:bg-blue-400",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setAllowCookie(1)))
          }, "Close"),
          _createElementVNode("button", {
            class: "p-2 border border-black rounded focus:bg-red-500 hover:bg-red-500",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {setAllowCookie(0); deleteAllCookies()})
          }, "Decline"),
          _createElementVNode("button", {
            class: "p-2 border border-black rounded focus:bg-primary-default hover:bg-primary-default",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setAllowCookie(1)))
          }, "Accept")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})